import * as React from 'react';
import Link from 'next/link';

interface SitemapListItemProps {
    children: string | React.ReactNode;
    link: string;
    target?: string;
}

const SitemapListItem = (props: SitemapListItemProps) => {
    const { children, link, target } = props;

    return (
        <li className="flex justify-start items-center self-stretch relative pb-4">
            <div className="flex justify-start items-center self-stretch relative gap-2.5 pr-2">
                <div className="w-1 h-1 bg-[#d9d9d9]" />
            </div>
            <Link href={link}>
                <a className="flex-grow text-lg text-left text-[#5637cd] hover:text-gray-600" target={target}>
                    <>{children}</>
                </a>
            </Link>
        </li>
    );
};

export default SitemapListItem;
